<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
    }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
    }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Inventory Dashboard</h3>

      <div class="search_bar mb-3">
        <b-row v-if="this.$store.state.user_obj.account_type == 'admin'">
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file" placeholder="Choose a file..."></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="12" sm="12" md="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.status_selected" :options="status_options" />
          </b-col>
          <b-col cols="12" sm="12" md="3" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="SKU"
              v-model="search_criteria.keyword"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="exportCSV"
              v-if="checkPermission($store.state.user_obj, 'Warehouse Management', 'Inventory - Dashboard', 'Export CSV', true)">Export</b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="exportCSVClient"
              v-if="checkPermission($store.state.user_obj, 'Warehouse Management', 'Inventory - Dashboard', 'Export Client CSV', true)">Export
              Client View</b-button>
          </b-col>
        </b-row>

        <b-row class="mt-2 ">
          <b-col>
            <strong>Column Filters</strong>
          </b-col>
        </b-row>
        <b-row class="">
          <b-col>
            <!-- <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_total"
              :value="true"
              v-model="col_filter.cnt_total"
              inline
            >
              Total
            </b-form-checkbox> -->

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_active" :value="true"
              v-model="col_filter.cnt_active" inline @change="onColumnFilterClick('cnt_active')">
              Active
            </b-form-checkbox>

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_committed" :value="true"
              v-model="col_filter.cnt_committed" @change="onColumnFilterClick('cnt_committed')" inline>
              Committed
            </b-form-checkbox>

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_damaged" :value="true"
              v-model="col_filter.cnt_damaged" @change="onColumnFilterClick('cnt_damaged')" inline>
              Damaged
            </b-form-checkbox>

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_hold" :value="true" v-model="col_filter.cnt_hold"
              @change="onColumnFilterClick('cnt_hold')" inline>
              Hold
            </b-form-checkbox>

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_expired" :value="true"
              v-model="col_filter.cnt_expired" @change="onColumnFilterClick('cnt_expired')" inline>
              Expired
            </b-form-checkbox>

            <b-form-checkbox class="chkbox_row" plain id="chkbox_cnt_other" :value="true" v-model="col_filter.cnt_other"
              @change="onColumnFilterClick('cnt_other')" inline>
              Other
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-table id="btable_main" responsive small outlined striped hover sticky-header="500px" :items="items"
        :fields="fields">
        <template v-slot:head(cnt_total)="data">
          <div class="div_cnt">
            Total
            <span class="toggle_qty" v-if="!showQty" @click="toggleQty">Expand</span>
            <span class="toggle_qty" v-if="showQty" @click="toggleQty">Hide</span>
          </div>
        </template>

        <template v-slot:cell(cnt_total)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_total) }}
          </div>
        </template>

        <template v-slot:head(cnt_active)="data">
          <div class="div_cnt">
            Active
            <span class="toggle_qty" v-if="!showQtyActive" @click="toggleQtyActive">Expand</span>
            <span class="toggle_qty" v-if="showQtyActive" @click="toggleQtyActive">Hide</span>
          </div>
        </template>

        <template v-slot:cell(cnt_active)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active) }}
          </div>
        </template>

        <template v-slot:head(cnt_active_available)="data">
          <div class="div_cnt">
            Active[AV]
          </div>
        </template>

        <template v-slot:cell(cnt_active_available)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active_available) }}
          </div>
        </template>

        <template v-slot:head(cnt_active_reserved)="data">
          <div class="div_cnt">
            Active[RV]
          </div>
        </template>

        <template v-slot:cell(cnt_active_reserved)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active_reserved) }}
          </div>
        </template>

        <template v-slot:head(cnt_damaged)="data">
          <div class="div_cnt">
            Damaged
          </div>
        </template>

        <template v-slot:cell(cnt_damaged)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_damaged) }}
          </div>
        </template>

        <template v-slot:head(cnt_hold)="data">
          <div class="div_cnt">
            Hold
          </div>
        </template>

        <template v-slot:cell(cnt_hold)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_hold) }}
          </div>
        </template>

        <template v-slot:head(cnt_expired)="data">
          <div class="div_cnt">
            Expired
          </div>
        </template>

        <template v-slot:cell(cnt_expired)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_expired) }}
          </div>
        </template>

        <template v-slot:head(cnt_committed)="data">
          <div class="div_cnt">
            Committed
          </div>
        </template>

        <template v-slot:cell(cnt_committed)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_committed) }}
          </div>
        </template>

        <template v-slot:head(cnt_other)="data">
          <div class="div_cnt">
            Other
          </div>
        </template>

        <template v-slot:cell(cnt_other)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_other) }}
          </div>
        </template>

        <template v-slot:cell(updated_at)="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <template v-slot:head(expired)="data">
          <div class="div_cnt">
            Expired
          </div>
        </template>

        <template v-slot:cell(expired)="data">
          <div class="dot_container">
            <div v-if="!data.item.cnt_expired || data.item.cnt_expired == 0" class="dot_expired"></div>
            <div v-if="data.item.cnt_expired > 0" class="dot_expired red_light"></div>
          </div>
        </template>

        <template v-slot:head(critical_level)="data">
          <div class="div_cnt">
            Critical Level
          </div>
        </template>

        <template v-slot:cell(critical_level)="data">
          <!-- <div class="dot_container">
            <div
            v-if="data.item.cnt_total >= crit_lv_yellow_to"
             class="dot_critical_level"></div>
          <div
            v-if="data.item.cnt_total >= crit_lv_yellow_from && data.item.cnt_total < crit_lv_yellow_to"
             class="dot_critical_level yellow_light"></div>
             <div
            v-if="data.item.cnt_total < crit_lv_yellow_from"
             class="dot_critical_level red_light"></div>
          </div> -->
          <div class="dot_container">
            <div v-if="data.item.cnt_active >= (data.item.critical_threshold * 2)" class="dot_critical_level"></div>
            <div
              v-if="data.item.cnt_active >= data.item.critical_threshold && data.item.cnt_active < (data.item.critical_threshold * 2)"
              class="dot_critical_level yellow_light"></div>
            <div v-if="data.item.cnt_active < data.item.critical_threshold" class="dot_critical_level red_light">
            </div>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button v-if="breakdown_items && breakdown_items.length > 0" class="btn-action" size="sm" variant="info" @click="openDetailModal(data.item)">
            View Detail
          </b-button>
        </template>

        <template v-slot:cell(vendor)="data">
          {{ data.item.vendor || "-" }}
        </template>

        <template v-slot:cell(brand)="data">
          {{ data.item.brand || "-" }}
        </template>

      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-modal id="detail-modal" ref="detailModal" title="Product Details" hide-footer size="xl" fullscreen>
        <!-- Product Summary -->
        <div class="product-summary p-3">
          <b-row>
            <b-col cols="6"><b>Product SKU:</b> {{ selectedProductSummary.product_sku }}</b-col>
            <b-col cols="6"><b>Channel:</b> {{ selectedProductSummary.channel }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="6"><b>Lot Number:</b> {{ selectedProductSummary.vendor_lot_number }}</b-col>
            <b-col cols="6"><b>Stock-In Date:</b> {{ displayDate(selectedProductSummary.stock_in_date) }}</b-col>
          </b-row>
          <b-row>
            <b-col cols="6"><b>Location:</b> {{ selectedProductSummary.location }}</b-col>
            <b-col cols="6"><b>Inventory Type:</b> {{ selectedProductSummary.inventory_type }}</b-col>
          </b-row>
        </div>

        <hr />

        <!-- Client and Quantity Table -->
        <b-table responsive small outlined striped hover :items="selectedProductDetails" :fields="summaryFields">
          <template v-slot:cell(client)="detail">
            <div>{{ detail.item.client }}</div>
          </template>
          <template v-slot:cell(cnt_total)="detail">
            <div>{{ displayQty(detail.item.cnt_total) }}</div>
          </template>
          <template v-slot:cell(cnt_active)="detail">
            <div>{{ displayQty(detail.item.cnt_active) }}</div>
          </template>
          <template v-slot:cell(cnt_active_available)="detail">
            <div>{{ displayQty(detail.item.cnt_active_available) }}</div>
          </template>
          <template v-slot:cell(cnt_active_reserved)="detail">
            <div>{{ displayQty(detail.item.cnt_active_reserved) }}</div>
          </template>
          <template v-slot:cell(cnt_committed)="detail">
            <div>{{ displayQty(detail.item.cnt_committed) }}</div>
          </template>
          <template v-slot:cell(cnt_hold)="detail">
            <div>{{ displayQty(detail.item.cnt_hold) }}</div>
          </template>
          <template v-slot:cell(cnt_expired)="detail">
            <div>{{ displayQty(detail.item.cnt_expired) }}</div>
          </template>
          <template v-slot:cell(cnt_damaged)="detail">
            <div>{{ displayQty(detail.item.cnt_damaged) }}</div>
          </template>
          <template v-slot:cell(cnt_other)="detail">
            <div>{{ displayQty(detail.item.cnt_other) }}</div>
          </template>
          <template v-slot:cell(qty)="detail">
            <div>{{ displayQty(detail.item.qty) }}</div>
          </template>
        </b-table>

        <b-button variant="secondary" block @click="$refs.detailModal.hide()">Close</b-button>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields_show_qty = [
  // {
  //   key: "category",
  //   label: "Primary Category"
  // },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "channel_sku",
    label: "Channel SKU",
    // class: "hide"
  },
  {
    key: "other_sku",
    label: "Other SKU"
  },
  {
    key: "vendor",
    label: "Vendor"
  },
  {
    key: "brand",
    label: "Brand"
  },
  {
    key: "product_description",
    label: "Product Description"
  },
  {
    key: "cnt_total",
    label: "Total"
  },
  {
    key: "cnt_active",
    label: "Active",
    class: "hide"
  },
  {
    key: "cnt_active_available",
    label: "Active[AV]",
    class: "hide"
  }, {
    key: "cnt_active_reserved",
    label: "Active[RV]",
    class: "hide"
  },
  {
    key: "cnt_committed",
    label: "Committed",
    class: "hide"
  },
  {
    key: "cnt_hold",
    label: "Hold",
    class: "hide"
  },
  {
    key: "cnt_expired",
    label: "Expired",
    class: "hide"
  },
  {
    key: "cnt_damaged",
    label: "Damaged",
    class: "hide"
  },
  {
    key: "cnt_other",
    label: "Other",
    class: "hide"
  },
  {
    key: "expired",
    label: "Expired",
  },
  {
    key: "critical_level",
    label: "Critical Level"
  },
  {
    key: "last_stockout_date",
    label: "Last Stockout Date"
  },
  {
    key: "action",
    label: "Action"
  }
];

const fields_hide_qty = [
  {
    key: "product_sku",
    label: "SKU"
  },
  {
    key: "product_description",
    label: "Description"
  },
  {
    key: "cnt_total",
    label: "Total"
  },
  {
    key: "expired",
    label: "Expired"
  },
  {
    key: "critical_level",
    label: "Critical Level"
  }
];

import global_function from "../mixins/global_function";

export default {
  name: "InventoryControl",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [global_function],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      showQtyActive: false,
      crit_lv_yellow_from: 100,
      crit_lv_yellow_to: 200,
      col_filter: {
        cnt_total: true,
        cnt_active: false,
        cnt_damaged: false,
        cnt_hold: false,
        cnt_expired: false,
        cnt_committed: false,
        cnt_other: false
      },
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      breakdown_items: [],
      showQty: false,
      fields: fields_show_qty,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      breakdown_total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Expired",
          text: "Expired"
        },
        {
          value: "Critical Level",
          text: "Critical Level"
        }
      ],
      selectedProductDetails: [],
      selectedProductSummary: false,
      summaryFields: [
      {
          key: "client",
          label: "Client"
        },
        {
          key: "cnt_total",
          label: "Total"
        },
        {
          key: "cnt_active",
          label: "Active"
        },
        {
          key: "cnt_active_available",
          label: "Active[AV]"
        }, {
          key: "cnt_active_reserved",
          label: "Active[RV]"
        },
        {
          key: "cnt_committed",
          label: "Committed"
        },
        {
          key: "cnt_hold",
          label: "Hold"
        },
        {
          key: "cnt_expired",
          label: "Expired"
        },
        {
          key: "cnt_damaged",
          label: "Damaged"
        },
        {
          key: "cnt_other",
          label: "Other"
        },
      ],
      detailedFields: [
        { key: "client", label: "Client" },
        { key: "product_sku", label: "Product SKU" },
        { key: "channel_sku", label: "Channel SKU" },
        { key: "qty", label: "Qty" },
        { key: "expiration_date", label: "Expiration Date" },
        { key: "stock_in_date", label: "Stock-In Date" }
      ]
    };
  },
  async created() {
    // this.fields[1].class = 'hide';
    // if(this.$store.state.user_obj.user_id == '391'){
    //   this.fields[1].class = '';
    // }

    await this.getInventoryControl();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    onColumnFilterClick(column_name) {
      let cnt_indexs = {
        'cnt_active': 7,
        'cnt_committed': 10,

        'cnt_hold': 11,
        'cnt_expired': 12,
        'cnt_damaged': 13,
        'cnt_other': 14
      };
      let cnt_index = cnt_indexs[column_name];
      if (this.col_filter[column_name]) {
        this.fields[cnt_index].class = "hide";
      } else {
        this.fields[cnt_index].class = "";
      }
      this.$root.$emit('bv::refresh::table', 'btable_main');
    },

    toggleQty() {
      // this.fields[8].class = 'hide';
      // console.log(this.fields);

      if (this.showQty) {
        this.showQty = false;
        let cnt_indexs = [7, 10, 11, 12, 13, 14];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = 'hide';
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = false;
        }

      } else {
        this.showQty = true;
        let cnt_indexs = [6, 7, 10, 11, 12, 13, 14];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = '';
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = true;
        }
      }

      this.$root.$emit('bv::refresh::table', 'btable_main');
    },

    toggleQtyActive() {
      // this.fields[8].class = 'hide';
      // console.log(this.fields);

      if (this.showQtyActive) {
        this.showQtyActive = false;
        let cnt_indexs = [8, 9];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = 'hide';
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = false;
        }

      } else {
        this.showQtyActive = true;
        let cnt_indexs = [8, 9];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = '';
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = true;
        }
      }

      this.$root.$emit('bv::refresh::table', 'btable_main');
    },

    number_formatter: value => {
      if (!value) {
        return '-';
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // exportCSV() {
    //   let export_url = process.env.VUE_APP_API_HOST+"/export_inventory_control.php?";
    //   export_url += "&client_id=" + this.$store.state.user_obj.client_id+"&user_id=" + this.$store.state.user_obj.user_id;
    //   export_url = encodeURI(export_url);
    //   window.open(export_url, "_blank");
    // },

    exportCSV() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let export_type = "inventory_control";
      if (this.$store.state.user_obj.user_id == '391') {
        export_type = "inventory_control_aml";
      }

      this.$http({
        url:
          this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          "export_type": export_type,
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "inventory_dashboard.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportCSVClient() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          "export_type": "client_inventory_control",
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "client_inventory.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getInventoryControl() {
      //
      if (this.$store.state.user_obj.client_id == '29') {
        this.crit_lv_yellow_from = 1;
        this.crit_lv_yellow_to = 3;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inventory_control_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.items = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);

      this.breakdown_items = response.data.breakdown_products;
      this.breakdown_total_rows = parseInt(response.data.breakdown_total_rows);
      this.loader.hide();
    },

    onSearch() {
      this.getInventoryControl();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getInventoryControl();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_inventory_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        window.location.reload();
      }
    },
    openDetailModal(item) {
      this.selectedProductSummary = { ...item }; // Store the selected product's summary
      this.selectedProductDetails = this.getFullProductDetails(item);
      this.$refs.detailModal.show();
    },

    getFullProductDetails(groupedItem) {
      // Group by client and sum quantities
      const groupedDetails = {};

      this.breakdown_items.forEach(item => {
        if (
          item.product_sku === groupedItem.product_sku
        ) {
          if (!groupedDetails[item.client_id]) {
            groupedDetails[item.client_id] = {
              client: item.client,
              "cnt_total": 0,
              "cnt_active": 0,
              "cnt_active_available": 0,
              "cnt_active_reserved": 0,
              "cnt_committed": 0,
              "cnt_hold": 0,
              "cnt_expired": 0,
              "cnt_damaged": 0,
              "cnt_other": 0,
            };
          }
          groupedDetails[item.client_id].cnt_total += parseInt(item.cnt_total);
          groupedDetails[item.client_id].cnt_active += parseInt(item.cnt_active);
          groupedDetails[item.client_id].cnt_active_available += parseInt(item.cnt_active_available);
          groupedDetails[item.client_id].cnt_active_reserved += parseInt(item.cnt_active_reserved);
          groupedDetails[item.client_id].cnt_committed += parseInt(item.cnt_committed);
          groupedDetails[item.client_id].cnt_hold += parseInt(item.cnt_hold);
          groupedDetails[item.client_id].cnt_expired += parseInt(item.cnt_expired);
          groupedDetails[item.client_id].cnt_damaged += parseInt(item.cnt_damaged);
          groupedDetails[item.client_id].cnt_other += parseInt(item.cnt_other);
        }
      });

      return Object.values(groupedDetails);
    },

    displayQty(qty) {
      if (qty == 0 || qty == "") {
        return "-";
      } else {
        return this.number_formatter(qty);
      }
    },

  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.div_cnt {
  text-align: center;
}

.hide {
  display: none;
}

.toggle_qty {
  font-size: 12px;
  border: 1px solid #eaeaea;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/InventoryControl.vue